import { useCallback, useRef } from 'react';

import { useGraphQLMutation } from '@betterment/graphql';

import { CapitalizeWindowEvent } from './useCapitalizeWindowEvents';

import { ProcessCapitalizeWindowEventDocument } from '../graphql/mutation.processCapitalizeWindowEvent.generated';

const useSerializedWindowEventMutationHandler = () => {
  const [processWindowEvent] = useGraphQLMutation(ProcessCapitalizeWindowEventDocument);
  const mutationQueue = useRef<Promise<void>>(Promise.resolve());

  const enqueueProcessWindowEventMutation = useCallback(
    (event: CapitalizeWindowEvent) => {
      mutationQueue.current = mutationQueue.current.then(async () => {
        try {
          const { data: mutationResult } = await processWindowEvent({
            variables: {
              input: {
                eventPayload: event,
              },
            },
          });

          if (mutationResult?.processCapitalizeWindowEvent.displayableErrors[0]) {
            window.console.error(
              'Capitalize window event error',
              mutationResult.processCapitalizeWindowEvent.displayableErrors[0].message
            );
          }
        } catch (error) {
          window.console.error('Error processing window event', error);
        }
      });
    },
    [processWindowEvent]
  );

  return enqueueProcessWindowEventMutation;
};

export default useSerializedWindowEventMutationHandler;
